import styled from "@emotion/styled";

export const StyledForm = styled.div`
  .text-label {
    font-size: 0.625rem;
    margin-bottom: 0.25rem !important;
    color: #A7A7A7;
    font-weight: normal!important;
  }
`;